import { KTIcon } from "../../../../_metronic/helpers";

const AddToBlacklistModalHeader = ({ setOpenModal, type }) => {
  return (
    <div className="modal-header">
      <h2 className="fw-bolder">Add Blacklist {type === '1' ? 'Email' : type === '2' ? 'Phone' : ''}</h2>
      <div
        className="btn btn-icon btn-sm btn-active-icon-primary"
        data-kt-users-modal-action="close"
        onClick={() => setOpenModal(false)}
        style={{ cursor: "pointer" }}
      >
        <KTIcon iconName="cross" className="fs-1" />
      </div>
    </div>
  );
};

export { AddToBlacklistModalHeader };
